<div class="{{'tw-grid ' + externalClass}}" style="display:grid">
  <label for="@next" class="tw-text-s tw-font-semibold tw-font-base-850 tw-mb-1" [class.form-required]="required" >{{label}}</label>
  <ng-content></ng-content>
</div>
